import { ReferringDoctor } from './referring-doctor.model';
import { ClinicLocation } from '../clinic-location';
import { Doctor } from '../doctor/doctor.model';
import { BaseDiagnosesTreatment } from '../diagnose/diagnoses&treatment.model';
import moment from 'moment';
import { StickyNote } from './sticky-note.model';

export class Client {
  public id: number;
  public first_name: string;
  public middle_name: string;
  public last_name: string;
  public email: string;
  public avatar: string;
  public birth_date: Date;
  public last_visit: Date;
  public doctor: Doctor;
  public diagnoses: BaseDiagnosesTreatment[];
  public treatments: BaseDiagnosesTreatment[];
  public notes: any[];
  public picture: string;
  public has_password: boolean;
  public phone_number: string;
  public referring_doctor: ReferringDoctor;
  public is_deleted: boolean;
  public signed: boolean;
  public forms: any[];
  public next_appt_date: null;
  public remote_id: number;
  public mrn: any;
  public location: ClinicLocation[];
  public password: string;
  public _selected?: boolean;
  public stickyNote: StickyNote;
  public amazing_transformation: boolean;
  public appointments?: any[];

  // TODO: next task add client
  constructor(data: any = {}) {
    this.id = data.id || null;
    this.first_name = data.first_name || null;
    this.last_name = data.last_name || null;
    this.middle_name = data.middle_name || null;
    this.email = data.email || null;
    this.avatar = data.avatar || null;
    this.birth_date = data.birth_date || null;
    this.last_visit = data.last_visit || null;
    this.doctor = (data.doctor && new Doctor(data.doctor)) || null;
    this.diagnoses = data.diagnoses || [];
    this.treatments = data.treatments || [];
    this.notes = data.notes || [];
    this.picture = data.picture || null;
    this.has_password = data.has_password || null;
    this.phone_number = data.phone_number || null;
    this.referring_doctor =
      (data.referring_doctor && new ReferringDoctor(data.referring_doctor)) || null;
    this.is_deleted = data.is_deleted || false;
    this.signed = data.signed || false;
    this.forms = data.forms || [];
    this.next_appt_date = data.next_appt_date || null;
    this.remote_id = data.remote_id || null;
    this.mrn = data.mrn || null;
    this.location = data.location || null;
    this._selected = data._selected || false;
    this.stickyNote = data.sticky_note || null;
    this.amazing_transformation = data.amazing_transformation || false;
    this.password = data.password || null;
    this.appointments = data.appointments || [];
  }

  public get formattedName(): string {
    let middleName = !this.middle_name ? '' : this.middle_name;
    if (middleName && this.last_name.length + this.first_name.length + middleName.length > 30) {
      middleName = middleName[0].toUpperCase() + '.';
    }
    return `<strong>${this.last_name}</strong>, ${this.first_name} ${middleName}`;
  }

  public get fullName(): string {
    const middleName = !this.middle_name ? '' : this.middle_name;
    return `${this.last_name} ${this.first_name} ${middleName}`;
  }

  public get firstAndLast(): string {
    const first_name = this.first_name || '';
    const last_name = this.last_name || '';
    return `${first_name} ${last_name}`.trim();
  }

  public getAge(): number {
    return moment().diff(moment(this.birth_date), 'years');
  }
}
